import axios from '../../../utils/axios';
import { toast } from 'react-hot-toast';

export const prepareOrderForPrinting = (order) => {
    // Calculate subtotal from items if it's zero
    let calculatedSubtotal = 0;
    if (order.subtotal === 0 && order.items && order.items.length > 0) {
        calculatedSubtotal = order.items.reduce((sum, item) => {
            return sum + (parseFloat(item.price) || 0);
        }, 0);
    }
    
    // Ensure payment_method is set
    if (!order.payment_method) {
    
    }
    
    return {
        ...order,
        // Ensure required fields for receipt printing are present
        payment_method: order.payment_method || 'cash', // Default to cash if not specified
        customer_type: order.customer_type || 'customer', // Default to customer if not specified
        company_name: order.company_name || '',
        company_tax_number: order.company_tax_number || '',
        // Ensure numeric values with fallbacks
        subtotal: parseFloat(order.subtotal) || calculatedSubtotal || 0,
        tax: parseFloat(order.tax) || 0,
        total: parseFloat(order.total) || 0,
        delivery_fee: parseFloat(order.delivery_fee) || 0,
        // If items exist, ensure their price values are correct
        items: (order.items || []).map(item => {

            
            // Preserve the exact quantity from the original order
            const quantity = parseFloat(item.quantity) || 1;
            
            // Calculate price and unit price correctly
            const unitPrice = parseFloat(item.unit_price) || 0;
            const price = parseFloat(item.price) || (unitPrice * quantity);
            

            
            return {
                ...item,
                unit_price: unitPrice,
                price: price,
                quantity: quantity
            };
        }),
        // Preserve the original QR code format from backend (base64 SVG)
        // Only generate a fallback if absolutely necessary
        qr_code: order.qr_code || `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=ORDER-${order.id || order.order_id || 'unknown'}`
    };
};

export const loadPrinterSettings = async (language) => {
    // Try to get settings from localStorage first
    const settingsString = localStorage.getItem('posSettings');
    let settings = settingsString ? JSON.parse(settingsString) : null;
    
    if (!settings || !settings.printing || !settings.printing.printer_name) {
        // Try to load settings from API if not available in localStorage
        try {
            toast.loading(language === 'ar' ? 'جاري تحميل إعدادات الطابعة' : 'Loading printer settings...');
            const response = await axios.get('/settings');
            if (response.data) {
                settings = response.data;
                
                // Create default printing settings if they don't exist
                if (!settings.printing) {
                    settings.printing = {
                        printer_name: 'default',
                        printer_type: 'thermal',
                        paper_size: '80mm',
                        paper_height: 'auto',
                        font_size: '10',
                        copies: '1',
                        auto_print: true
                    };
                }
                
                // Enable QR code in receipt settings
                if (!settings.receipts) {
                    settings.receipts = {
                        qr_code: true,
                        footer_text: 'Thank you for your purchase!'
                    };
                } else {
                    settings.receipts.qr_code = true;
                }
                
                // Save settings to localStorage for future use
                localStorage.setItem('posSettings', JSON.stringify(settings));
                toast.dismiss();
            }
        } catch (error) {
            console.error('Failed to get settings:', error);
            toast.error(language === 'ar' ? 'فشل في تحميل إعدادات الطابعة' : 'Failed to load printer settings');
            
            // Create default settings
            settings = {
                printing: {
                    printer_name: 'default',
                    printer_type: 'thermal',
                    paper_size: '80mm',
                    paper_height: 'auto',
                    font_size: '10',
                    copies: '1',
                    auto_print: true
                },
                receipts: {
                    qr_code: true,
                    footer_text: 'Thank you for your purchase!'
                },
                restaurant: {
                    name: 'Khabeertech Restaurant',
                    name_ar: 'مطعم خبيرتك',
                    address: '123 Main Street',
                    address_ar: '١٢٣ الشارع الرئيسي',
                    phone: '123-456-7890',
                    tax_number: '123456789'
                }
            };
        }
    } else {
        // Ensure QR code is enabled in receipt settings
        if (!settings.receipts) {
            settings.receipts = {
                qr_code: true,
                footer_text: 'Thank you for your purchase!'
            };
        } else {
            settings.receipts.qr_code = true;
        }
        
        // Save updated settings
        localStorage.setItem('posSettings', JSON.stringify(settings));
    }
    
    return settings;
};

export const getDefaultSettings = () => {
    // Create default settings if not available in localStorage
    const settingsString = localStorage.getItem('posSettings');
    let settings = settingsString ? JSON.parse(settingsString) : {};
    
    // Ensure required structure exists
    if (!settings.printing) {
        settings.printing = {
            printer_name: 'default',
            printer_type: 'thermal',
            paper_size: '80mm',
            paper_height: 'auto',
            font_size: '10',
            copies: '1',
            auto_print: true
        };
    }

    // Ensure restaurant info exists for receipt header
    if (!settings.restaurant) {
        settings.restaurant = {
            name: 'Khabeertech Restaurant',
            name_ar: 'مطعم خبيرتك',
            address: '123 Main Street',
            address_ar: '١٢٣ الشارع الرئيسي',
            phone: '123-456-7890',
            tax_number: '123456789'
        };
    }

    return settings;
};
